import gql from 'graphql-tag';

export const UpdateContentPermissionsMutation = gql`
	mutation UpdateContentPermissionsMutation(
		$contentId: ID!
		$input: [UpdateContentPermissionsInput]!
	) {
		updateContentPermissions(contentId: $contentId, input: $input) {
			status
		}
	}
`;
